import React from 'react';
import { experience } from '../mock';
import SectionHeader from './SectionHeader';

export default function Experience() {
  return (
    <section id="experience" className="py-20 md:py-28 border-t border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          kicker={experience.kicker}
          title={experience.title}
          description={experience.description}
        />

        <div className="relative">
          <div className="absolute left-[8px] md:left-[12px] top-2 bottom-2 w-px bg-neutral-800" />
          <ol className="space-y-14 md:space-y-20">
            {experience.items.map((item) => (
              <li key={item.role + item.period} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
                <div className="md:col-span-4 relative pl-8 md:pl-10">
                  <span className="absolute left-0 top-2 w-4 h-4 rotate-45 bg-[#ED2D5C]" />
                  <p className="mono text-[11px] tracking-[0.22em] text-neutral-400">{item.period}</p>
                  <p className="mono text-[11px] tracking-[0.22em] text-neutral-500 mt-1">{item.location}</p>
                </div>
                <div className="md:col-span-8">
                  <h3 className="font-display text-white text-[26px] md:text-[34px] leading-[1.02]">
                    {item.role}
                  </h3>
                  <p className="mt-3 text-neutral-400 text-[14px] md:text-[15px]">{item.company}</p>
                  <ul className="mt-5 space-y-3">
                    {item.bullets.map((b, i) => (
                      <li key={i} className="flex gap-3 text-neutral-300 text-[14px] md:text-[15px] leading-relaxed">
                        <span className="mt-2.5 w-3 h-px bg-[#ED2D5C] shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
